import { createContext, useContext, useEffect, useState } from 'react';

import { ConfigService } from '@/v1/main/domain/config';

interface DeviceContextProps {
    isPwaMode: boolean;
    isMobileMode: boolean;
}

interface DeviceProviderProps {
    usecase: ConfigService;
    children: React.ReactNode;
}

const DeviceContext = createContext<DeviceContextProps | undefined>(undefined);

export const DeviceProvider = ({ usecase, children }: DeviceProviderProps) => {
    const [isPwaMode, setIsPwaMode] = useState<boolean>(usecase.isPwaMode());
    const [isMobileMode, setIsMobileMode] = useState<boolean>(
        usecase.isMobileMode()
    );

    useEffect(() => {
        const onResize = () => {
            setIsPwaMode(usecase.isPwaMode());
            setIsMobileMode(usecase.isMobileMode());
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return (
        <DeviceContext.Provider value={{ isPwaMode, isMobileMode }}>
            {children}
        </DeviceContext.Provider>
    );
};

export const useDevice = () => {
    const context = useContext(DeviceContext);
    if (context === undefined) {
        throw new Error('useDevice must be used within a DeviceProvider');
    }
    return context;
};
